module.exports = __webpack_public_path__ + "static/media/map.94b1b215.mtl";